import { useWatch } from 'react-hook-form';
import { ApplicationData } from '../application/ApplicationDataStore';
import { ReactNode } from 'react';

export const HasCoApplicantFieldWatcher = ({
    children,
}: {
    children: (state: boolean) => ReactNode;
}) => {
    const hasCoApplicant = useWatch<ApplicationData['coApplicant']>({ name: 'hasCoApplicant' });

    return children(hasCoApplicant as boolean);
};
